<template>
  <div id="dashboard" class="">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-9">
          <h1 style="margin-left: 7px;">Bienvenido a tu generador de conceptos</h1>
          <!-- <p v-if="email">Your email address: {{ email }}</p> -->
          <div v-if="!expired" class="contratos container-fluid">
            <p>Para empezar elige una de las siguientes opciones:</p>
            <!-- <button class="button-contract" @click="goToArriendo">Arrendamiento</button> -->
            <!-- <br>
            <button class="button-contract" @click="goToContractViewer">Prestacion de servicios</button> -->
            <br>
            <!-- <button  class="button-contract" @click="goToPretension">Pretension</button> -->
            <button  class="btn btn-legiox" @click="goToPretensionAvanzado">Empezar un concepto de repetición</button>
          <div style="margin-top: 10px;">
            <form v-if="!expired" @submit.prevent="processFile" class="">
            <label for="inputFile" class="btn btn-secondary" style="margin-top: 8px; margin-left:-3px; padding-top: 10px;">Selecciona tu reparto</label>
            <input id="inputFile" class="input" style="display: none;" type="file" @change="handleFileUpload" />
            <button class="btn btn-legiox" type="submit">Cargar y procesar</button>
          </form>
          </div>
        </div>
        
      </div>
      <div class="col-6 col-md-3">
          <img src="./img/collegia.png" class="rounded" alt="...">
        </div>
    </div>

    <div style="min-height:500px;">
      <div v-if="jsonData && jsonData.length" >
      <h2>Reparto</h2>
      <table border="1" class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th>Actions</th>
            <th v-for="(header, index) in tableHeaders" :key="index">{{ header }}</th>
            <!-- <th>Actions</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rowIndex) in jsonData" :key="rowIndex">
            <td>
              <!-- <button class="btn  btn-outline-secondary btn-small" v-if="editIndex !== rowIndex" @click="startEdit(rowIndex, row)">Edit</button>
              <button class="btn  btn-outline-secondary btn-small" v-else @click="saveEdit(rowIndex)">Save</button>
              <button class="btn  btn-outline-secondary btn-small" v-if="editIndex === rowIndex" @click="cancelEdit">Cancel</button> -->
              <button class="btn  btn-outline-secondary btn-small"  @click="startPretension(row)">Iniciar</button>
            </td>
            <td v-for="(header, colIndex) in tableHeaders" :key="colIndex">
              <div v-if="editIndex === rowIndex">
                <input v-model="editRow[header]" />
              </div>
              <div v-else>
                {{ row[header] }}
              </div>
            </td>
            <!-- <td>
              <button v-if="editIndex !== rowIndex" @click="startEdit(rowIndex, row)">Edit</button>
              <button v-else @click="saveEdit(rowIndex)">Save</button>
              <button v-if="editIndex === rowIndex" @click="cancelEdit">Cancel</button>
              <button  @click="startPretension(row)">Pretension</button>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    
    <div class="pastContracts" v-if="contracts.length > 0">
      <h2>Contratos Pasados:</h2>
      <table  class="table table-hover">
        <thead>
          <th>Tipo de Contrato</th>
          <th>Nombre Arrendatario</th>
          <th>Direccion inmueble</th>
          <th></th>
        </thead>
        <tbody>
            <tr v-for="contract in contracts">
              <td>{{contract.tipo}}</td>
              <td>{{contract.arrendatario.nombre}}</td>
              <td>{{contract.inmueble.ubicacion}}</td>
              <td><b-button class="btn btn-edit" size="sm" variant="light"><b-icon-pencil ></b-icon-pencil></b-button>
              <b-button class="btn btn-edit" size="sm" variant="light" @click="viewContract(contract.docId)"><b-icon-file-richtext></b-icon-file-richtext></b-button>
                </td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
  </div>
</template>

<script>
  import fireStore from '../../helpers/db';
  import Papa from 'papaparse';
  import cloneDeep from 'lodash/cloneDeep';
  export default {
    data() {
      return {
        file: null,
        editIndex: null,
        editRow: {},
        expired: false
      };
    },
    computed: {
      email () {
        return !this.$store.getters.user ? '' : this.$store.getters.user.email
      },
      name(){
        return !this.$store.getters.userInfo ? 'Camilo' : this.$store.getters.userInfo
      },
      user(){
        return !this.$store.getters.user ? '-23' : this.$store.getters.user
      },
      contracts(){
        console.log('info'+ Array.isArray(this.$store.getters.contracts));
        return !this.$store.getters.contracts ? '' : this.$store.getters.contracts
      },
      jsonData(){
        console.log('getting previous data'+ (this.$store.getters.uploadedData));
        return !this.$store.getters.uploadedData ? '' : this.$store.getters.uploadedData
      },
      tableHeaders(){
        console.log('getting previous headers'+ (this.$store.getters.uploadedHeaders));
        return !this.$store.getters.uploadedHeaders ? '' : this.$store.getters.uploadedHeaders
      },
    },
    methods:{
      goToArriendo(){
        console.log('Entro al boton arriendo')
        this.$store.dispatch('goToArriendo')
      },
      goToContractViewer(){
        this.$store.dispatch('goToContractViewer')
      },
      goToPretension(){
        this.$store.dispatch('goToPretension')
      },
      goToPretensionAvanzado(){
        this.$store.dispatch('goToPretensionAvanzado')
      },
      viewContract(id){
        console.log('contract ID: '+id);
        this.$store.commit('setActiveContract', id);
        this.$store.dispatch('goToContractViewer');
      },
      handleFileUpload(event) {
        this.file = event.target.files[0];
      },
      processFile() {
        if (!this.file) {
          alert("Please select a file first!");
          return;
        }

        Papa.parse(this.file, {
          header: true,
          dynamicTyping: true,
          complete: (result) => {
            this.$store.commit('setUploadedHeaders', result.meta.fields);
            this.$store.commit('setUploadedData', result.data);
          },
          error: (error) => {
            console.error("Error parsing CSV file:", error);
            alert("Error parsing CSV file. Please try again.");
          }
        });
      },
      startEdit(index, row) {
        console.log(row);
        this.editIndex = index;
        this.editRow = cloneDeep(row);
      },
      saveEdit(index) {
        this.$set(this.jsonData, index, this.editRow);
        this.editIndex = null;
        this.editRow = {};
      },
      cancelEdit() {
        this.editIndex = null;
        this.editRow = {};
      },
      startPretension(data){
        this.$store.commit('setActivePretension', data);
        this.$store.dispatch('goToPretensionAvanzado');
      }
    },
    created () {
      console.log('Entro al dashboard: '+ this.email)
      this.$store.commit('clearActivePretension');
      var date  = new Date();
      var expiration = new Date('06-12-2025');
      console.log(date);
      console.log(expiration);
      if(date > expiration){
        console.log('greater date')
        this.expired = true;
      }
      
      // this.$store.dispatch('fetchUser2')
    }
  }
</script>

<style scoped>
  #dashboard{
    padding-left: 3%;
    padding-right: 3%;
    padding-top: 3%;
  }
  h1 {
    text-align: left;
  }
  .contratos{
    text-align: left;
    /* padding-left: 10%; */
  }
  .pastContracts{
    text-align: left;
    padding-top: 20px;
  }

  .btn-legiox{
    color: #fff;
    background-color: #563d7c;
    border-color: #563d7c;
    box-shadow: 0 0 0 0.2rem rgb(86 61 124);
  }
  .btn-legiox:focus{
    color: #fff;
    background-color: #3e216b;
    border-color: #563d7c;
    box-shadow: 0 0 0 0.2rem rgb(41, 23, 68);
  }
  .btn-legiox:hover{
    color: #fff;
    background-color: #3e216b;
    border-color: #3e216b;
    box-shadow: 0 0 0 0.2rem rgb(41, 23, 68);
  }
  .btn-legiox2{
    color: #fff;
    background-color: #6a5a83;
    border-color: #6a5a83;
    box-shadow: 0 0 0 0.2rem rgb(107, 82, 142);
  }
  .btn-legiox2:focus{
    color: #fff;
    background-color: #3e216b;
    border-color: #563d7c;
    box-shadow: 0 0 0 0.2rem rgb(41, 23, 68);
  }
  .btn-legiox2:hover{
    color: #fff;
    background-color: #3e216b;
    border-color: #3e216b;
    box-shadow: 0 0 0 0.2rem rgb(41, 23, 68);
  }

  .button-contract {
    border: 1px solid #3b3b3b;
    color: #3b3b3b;
    padding: 10px 20px;
    font: inherit;
    cursor: pointer;
    margin-top: 10px;
    width: 30%;
  }

  .btn-edit{

  }
  table {
    margin: 20px auto;
    border-collapse: collapse;
    width: 80%;
  }

  th, td {
    padding: 10px;
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/dashboard/dashboard.vue